<template>
    <layout v-bind:user="user"  v-bind:shops="shops" v-bind:brands="brands" v-bind:company="company" title="ブランド ダッシュボード" @selectList="displaySelectedBrand($event)">
        <main class="ly_main"><div class="wrap"><div class="inner">
            <!--Heading-->
            <h1 class="heading_page-title flex _y-center">
                <!-- EndUser -->
                <div v-if="(pageType == 1 && user.type != 0)" class="main"><span>My Select Room（ブランド）</span></div>
                <div v-if="(pageType == 2 && user.type != 0)" class="main"><span>My Select Room（ショールーム）</span></div>
                <div v-if="(pageType == 3 && user.type != 0)" class="main"><span>Shop</span></div>
                <div v-if="(pageType == 4 && user.type != 0)" class="main"><span>ShowRoom</span></div>
                <div v-if="(pageType == 5 && user.type != 0)" class="main"><span>My Select Room（ショップ）</span></div>
                <div v-if="(pageType == 6 && user.type != 0)" class="main"><span>My Select Room（ブランド）</span></div>
                <!-- Admin -->
                <div v-if="(pageType == 1 && user.type == 0) || (pageType == 6 && user.type == 0)" class="main"><span>{{shop.name}}のBrand</span></div>
                <div v-if="(pageType == 2 && user.type == 0) || (pageType == 4 && user.type == 0)" class="main"><span>{{shop.name}}のShowRoom</span></div>
                <div v-if="(pageType == 3 && user.type == 0) || (pageType == 5 && user.type == 0)" class="main"><span>{{brand.name}}のShop</span></div>
                <div class="controller flex _right _y-center">
                    <div class="form_search">
                        <form v-on:submit.prevent="search">
                            <input type="search" v-model="free_text">
                            <label for="submit-btn" class="md_svg-icon">
                                <SvgIconSearch />
                            </label>
                            <input type="submit" id="submit-btn">
                        </form>
                    </div><!--/.search-->
                </div><!--/.controller-->
            </h1><!--/.heading_page-title-->

            <div class="card_like-us _flex" style="margin-bottom: 8rem;">

                <div class="card" v-for="(partner, index) in mySelectRooms" v-bind:key="index">
                    <a :href="route(pageLink, partner.id)" class=""><span>MORE</span></a>
                    <img v-bind:src=" $store.state.const.AWS_S3_URL_HOST + partner.logo" alt="">
                    <div class="detail" style="position: relative;">
                        <h5>{{partner.name}}</h5>
                        <div class="role">
                            <select v-if="partner.staff" v-on:change="selectStaff($event, partner)">
                                <option value="" hidden>{{ partner.staff.name }}</option>
                                <option v-for="employee in allEmployees" v-bind:selected="employee.id == partner.staff.id" v-bind:key="employee.id" v-bind:value="employee.id">{{ employee.name }}</option>
                                <option value="未設定">未設定にする</option>
                            </select>
                            <select v-else v-on:change="selectStaff($event, partner)">
                                <option value="" hidden>未設定</option>
                                <option v-for="employee in allEmployees" v-bind:key="employee.id" v-bind:value="employee.id">{{ employee.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="btn_svg-icon _white" v-bind:class="{ _notice: partner.read != 0 }">
                        <a class="" v-on:click="getTalk(partner.id)">
                            <SvgIconChat />
                        </a>
                    </div>
                </div>
                <pagination v-if="showPagination" :list="links"/>
            </div>

            <h2 class="heading_component" v-if="pageType == 1"><span>LIKEしたブランド</span></h2>
            <h2 class="heading_component" v-if="pageType == 2"><span>LIKEしたショールーム</span></h2>
            <LikeUsCardComponent v-if="pageType == 1 || pageType == 2" v-bind:likeBrands="likeBrands"/>
            <AlertModal 
                v-if="showAlertModal" 
                @close="closeAlertModal" 
                :title="alert_modal_title" 
                :message="alert_modal_message"
                :mode="alert_modal_mode" 
            />
        </div></div><div class="heading_page-title-en"><span>{{backName}}</span></div></main>
    </layout>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import Pagination from '@/components/Admin/Pagination'
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'
    import { Link } from '@inertiajs/inertia-vue3'
    import LikeUsCardComponent from '@/components/Admin/ComponentList/18LikeUsCard'
    import AlertModal from '@/components/Admin/ComponentList/AlertModal'

    //Svg
    import SvgIconSearch from '@/components/EndUser/svg/SvgIconSearch'
    import SvgIconChat from '@/components/EndUser/svg/SvgIconChat'

    export default {
        components: {
            "layout": AdminLayout,
            "pagination": Pagination,
            "Link": Link,
            "LikeUsCardComponent": LikeUsCardComponent,
            "AlertModal": AlertModal,
            //Svg
            SvgIconSearch,
            SvgIconChat,
        },
        data() {
            return {
                list_index: 0,
                free_text: '',
                showPagination: false,
                links: '',
                select_id: 0,
                selectedStaffId: '',
                showAlertModal: false,
                alert_modal_title: '',
                alert_modal_message: '',
                alert_modal_mode: '',
                list_sorter: {column: "", order: ""},
                plan_validation: false,
            }
        },
        props: {
            user: Object,
            company: Object,
            employees: Object,
            shops: Object,
            brands: Object,
            freeText: Object,
            listIndex: Object,
            shopList: Object,
            brandList: Object,
            brandId: Object,
            shopId: Object,
            brand: Object,
            shop: Object,
            likeBrands: Object,
            listSorter: Object,
        },
        created() {
            this.setDefaultData();
        },
        methods: {
            displaySelectedBrand(index) {
                this.list_index = index;

                if (this.pageType == 3 || this.pageType == 4 || this.pageType == 5 || this.pageType == 6) {
                    var brand = this.brands[this.list_index];
                    this.brand_id = brand.id;
                    if (brand.plan == 1 && brand.subscription_status == 'active') {
                        this.search();
                    } else {
                        if (this.pageType == 3 || this.pageType == 4) {
                            this.plan_validation = true;
                            this.openAlertModal('error', 'BASICプランのみのご利用になります', 'BASICプランのみのご利用になります'); // 確認済み
                        } else if (this.pageType == 5 || this.pageType == 6) {
                            this.plan_validation = true;
                            this.openAlertModal('error', 'BASICプランのみのご利用になります', 'BASICプランのみのご利用になります'); // 確認済み
                        }
                    }
                } else {
                    this.search();
                }
            },
            setDefaultData() {
                this.free_text = this.freeText;
                this.list_index = this.listIndex;
                this.$store.state.const.index = this.listIndex;
                if(this.listSorter){
                    this.list_sorter = this.listSorter;
                }

                switch (this.pageType) {
                    case 1: //ショップ ブランド一覧の場合
                        if (this.brandList.data) {
                            this.showPagination = true;
                        }
                        for(var i in this.brandList.links) {
                            var link = this.brandList.links[i];
                            if (link.url) {
                                link.url = link.url + '&listIndex=' + this.listIndex;
                                if (this.freeText) {
                                    link.url = link.url + '&freeText=' + this.freeText;
                                }
                                if (this.shopId) {
                                    link.url = link.url + '&shop_id=' + this.shopId;
                                }
                            }
                        }
                        this.links = this.brandList;
                        if (this.listSorter) {
                            this.addSorterToLinks(this.listSorter, this.brandList.links);
                        }
                        break;
                    case 2: //ショップ ショールーム一覧の場合
                        if (this.brandList.data) {
                            this.showPagination = true;
                        }
                        for(var i in this.brandList.links) {
                            var link = this.brandList.links[i];
                            if (link.url) {
                                link.url = link.url + '&listIndex=' + this.listIndex;
                                if (this.freeText) {
                                    link.url = link.url + '&freeText=' + this.freeText;
                                }
                                if (this.shopId) {
                                    link.url = link.url + '&shop_id=' + this.shopId;
                                }
                            }
                        }
                        this.links = this.brandList;
                        if (this.listSorter) {
                            this.addSorterToLinks(this.listSorter, this.brandList.links);
                        }
                        break;
                    case 3: //ブランド ショップ一覧の場合
                        if (this.shopList.data) {
                            this.showPagination = true;
                        }
                        for(var i in this.shopList.links) {
                            var link = this.shopList.links[i];
                            if (link.url) {
                                link.url = link.url + '&listIndex=' + this.listIndex;
                                if (this.freeText) {
                                    link.url = link.url + '&freeText=' + this.freeText;
                                }
                                if (this.brandId) {
                                    link.url = link.url + '&brand_id=' + this.brandId;
                                }
                            }
                        }
                        this.links = this.shopList;
                        if (this.listSorter) {
                            this.addSorterToLinks(this.listSorter, this.shopList.links);
                        }
                        break;
                    case 4: //ブランド ショールーム一覧の場合
                        if (this.shopList.data) {
                            this.showPagination = true;
                        }
                        for(var i in this.shopList.links) {
                            var link = this.shopList.links[i];
                            if (link.url) {
                                link.url = link.url + '&listIndex=' + this.listIndex;
                                if (this.freeText) {
                                    link.url = link.url + '&freeText=' + this.freeText;
                                }
                                if (this.brandId) {
                                    link.url = link.url + '&brand_id=' + this.brandId;
                                }
                            }
                        }
                        this.links = this.shopList;
                        if (this.listSorter) {
                            this.addSorterToLinks(this.listSorter, this.shopList.links);
                        }
                        break;
                    case 5: //ショールーム ショップ一覧の場合
                        if (this.shopList.data) {
                            this.showPagination = true;
                        }
                        for(var i in this.shopList.links) {
                            var link = this.shopList.links[i];
                            if (link.url) {
                                link.url = link.url + '&listIndex=' + this.listIndex;
                                if (this.freeText) {
                                    link.url = link.url + '&freeText=' + this.freeText;
                                }
                                if (this.brandId) {
                                    link.url = link.url + '&brand_id=' + this.brandId;
                                }
                            }
                        }
                        this.links = this.shopList;
                        if (this.listSorter) {
                            this.addSorterToLinks(this.listSorter, this.shopList.links);
                        }
                        break;
                    case 6: //ショールーム ブランド一覧の場合
                        if (this.shopList.data) {
                            this.showPagination = true;
                        }
                        for(var i in this.shopList.links) {
                            var link = this.shopList.links[i];
                            if (link.url) {
                                link.url = link.url + '&listIndex=' + this.listIndex;
                                if (this.freeText) {
                                    link.url = link.url + '&freeText=' + this.freeText;
                                }
                                if (this.brandId) {
                                    link.url = link.url + '&brand_id=' + this.brandId;
                                }
                            }
                        }
                        this.links = this.shopList;
                        if (this.listSorter) {
                            this.addSorterToLinks(this.listSorter, this.shopList.links);
                        }
                        break;
                }
            },
            search() {
                var url = location.pathname;
                const form = reactive({
                    freeText: this.free_text,
                    listIndex: this.list_index,
                    shop_id: this.shopId,
                    brand_id: this.brandId,
                    listSorter: this.list_sorter
                })
                Inertia.get(url, form, {
                    onSuccess: (page) => {
                        this.free_text = '';
                    },
                })
            },
            selectStaff(event, partner) {
                if (event.target.value == '未設定') {
                    this.selectedStaffId = event.target.value;
                } else {
                    this.selectedStaffId = Number(event.target.value);
                } 
                var routeName = '';
                const url = location.pathname + location.search;
                if (this.pageType == 1) {
                    routeName = 'admin.shop.brands.select.staff';
                    if (this.user.shop_id) {
                        var shop_id = this.user.shop_id;
                    } else {
                        var shop_id = this.shops[this.list_index].id;
                    }
                    var data = reactive({
                        shop_id: shop_id,
                        selected_staff: this.selectedStaffId,
                        partner_id: partner.id,
                        url: url,
                    });
                }  else if (this.pageType == 2) {
                    routeName = 'admin.shop.showrooms.select.staff';
                    if (this.user.shop_id) {
                        var shop_id = this.user.shop_id;
                    } else {
                        var shop_id = this.shops[this.list_index].id;
                    }
                    var data = reactive({
                        shop_id: shop_id,
                        selected_staff: this.selectedStaffId,
                        partner_id: partner.id,
                        url: url,
                    });
                } else if (this.pageType == 3) {
                    routeName = 'admin.brand.shops.select.staff';
                    if (this.user.brand_id) {
                        var brand_id = this.user.brand_id;
                    } else {
                        var brand_id = this.brands[this.list_index].id;
                    }
                    var data = reactive({
                        brand_id: brand_id,
                        selected_staff: this.selectedStaffId,
                        partner_id: partner.id,
                        url: url,
                    });
                } else if (this.pageType == 4) {
                    routeName = 'admin.brand.showrooms.select.staff';
                    if (this.user.brand_id) {
                        var brand_id = this.user.brand_id;
                    } else {
                        var brand_id = this.brands[this.list_index].id;
                    }
                    var data = reactive({
                        brand_id: brand_id,
                        selected_staff: this.selectedStaffId,
                        partner_id: partner.id,
                        url: url,
                    });
                } else if (this.pageType == 5) {
                    routeName = 'admin.showroom.shops.select.staff';
                    if (this.user.brand_id) {
                        var brand_id = this.user.brand_id;
                    } else {
                        var brand_id = this.brands[this.list_index].id;
                    }
                    var data = reactive({
                        brand_id: brand_id,
                        selected_staff: this.selectedStaffId,
                        partner_id: partner.id,
                        url: url,
                    });
                } else if (this.pageType == 6) {
                    routeName = 'admin.showroom.brands.select.staff';
                    if (this.user.brand_id) {
                        var brand_id = this.user.brand_id;
                    } else {
                        var brand_id = this.brands[this.list_index].id;
                    }
                    var data = reactive({
                        brand_id: brand_id,
                        selected_staff: this.selectedStaffId,
                        partner_id: partner.id,
                        url: url,
                    });
                }
                Inertia.post(route(routeName), data, {
                    preserveScroll: true,
                    onError: (errors) => {
                        this.openAlertModal('error', 'エラー', errors); // 確認済み
                    },
                    onSuccess: visit => {
                        const message = partner.name + ' 様 の担当者を変更しました';
                        this.openAlertModal('success', '担当者変更', message); // 確認済み
                    },
                    onFinish: visit => {
                        this.selectedStaffId = '';
                    },
                })
            },
            getTalk(partner_id) {
                if (this.pageType == 1) {
                    var url = 'admin.shop.talk';
                    var form = reactive({
                        shop_id: this.select_id,
                        brand_id: partner_id
                    })
                } else if (this.pageType == 2) {
                    var url = 'admin.shop.talk';
                    var form = reactive({
                        shop_id: this.select_id,
                        brand_id: partner_id
                    })
                } else if (this.pageType == 3) {
                    var url = 'admin.brand.talk';
                    var form = reactive({
                        shop_id: partner_id,
                        brand_id: this.select_id
                    })
                } else if (this.pageType == 4) {
                    var url = 'admin.brand.talk';
                    var form = reactive({
                        showroom_id: partner_id,
                        brand_id: this.select_id
                    })
                } else if (this.pageType == 5) {
                    var url = 'admin.showroom.talk';
                    var form = reactive({
                        shop_id: partner_id,
                        brand_id: this.select_id
                    })
                } else if (this.pageType == 6) {
                    var url = 'admin.showroom.talk';
                    var form = reactive({
                        showroom_id: this.select_id,
                        brand_id: partner_id
                    })
                }

                // 未読マークを消すためaxiosを使用。リファクタリングしたい箇所
                axios.get(route(url, form))
                .then((res) => {
                    Inertia.reload({
                        onFinish: visit => {
                            Inertia.get(route(url, form))
                        },
                    })
                }).catch(error => {
                });
            },
            openAlertModal(mode, title, message) {
                this.alert_modal_mode = mode;
                this.alert_modal_title = title;
                this.alert_modal_message = message;
                this.showAlertModal = true;
            },
            closeAlertModal() {
                this.showAlertModal = false;
                this.alert_modal_mode = '';
                this.alert_modal_title = '';
                this.alert_modal_message = '';

                if (this.plan_validation){
                    if (this.pageType == 3 || this.pageType == 4) {
                        Inertia.get(route('admin.brand.dashboard'));
                    } else if (this.pageType == 5 || this.pageType == 6) {
                        Inertia.get(route('admin.showroom.dashboard'));
                    }
                }
            },
            clickSort(sorter){
                if(this.list_sorter.column !== sorter){ // 1回目クリックされたらascでソート
                    this.list_sorter.column = sorter;
                    this.list_sorter.order = "ASC";
                } else {
                    if(this.list_sorter.order == "ASC"){
                        this.list_sorter.order = "DESC"; // 2回目クリックされたらdescでソート
                    } else {
                        this.list_sorter.column = ""; // 3回目クリックされたらソートを外す
                        this.list_sorter.order = "";
                    }
                }
                const { column, order } = this.list_sorter;
                const form = reactive({
                    freeText: this.free_text,
                    listIndex: this.list_index,
                    shop_id: this.shopId,
                    brand_id: this.brandId,
                    listSorter: this.list_sorter
                })
                Inertia.get(location.pathname, form);
            },
            addSorterToLinks(sorter, links){
                for(var i in links) {
                    var link = links[i];
                    if (link.url) {
                        link.url = link.url + `&listSorter[column]=${sorter.column}&listSorter[order]=${sorter.order}`;
                    }
                }
            },
            getTriangle(name){
                if(name == this.list_sorter.column){
                    return this.list_sorter.order == "ASC" ? "▼" : "▲";
                } else return "▼";
            }
        },
        computed: {
            pageType() {
                if (location.pathname == '/admin/shop/brands') { //ショップ ブランド一覧の場合
                    return 1;
                } else if (location.pathname == '/admin/shop/showrooms') { //ショップ ショールーム一覧の場合
                    return 2;
                } else if (location.pathname == '/admin/brand/shops') { //ブランド ショップ一覧の場合 
                    return 3;
                } else if (location.pathname == '/admin/brand/showrooms') { //ブランド ショールーム一覧の場合 
                    return 4;
                } else if (location.pathname == '/admin/showroom/shops') { //ショールーム ショップ一覧の場合 
                    return 5;
                } else if (location.pathname == '/admin/showroom/brands') { //ショールーム ブランド一覧の場合 
                    return 6;
                }
            },
            pageLink() {
                if (this.pageType == 1) { //ショップ ブランド一覧の場合
                    return 'brand_detail';
                } else if (this.pageType == 2) { //ショップ ショールーム一覧の場合
                    return 'showroom_detail';
                } else if (this.pageType == 3) { //ブランド ショップ一覧の場合 
                    return 'shop_detail';
                } else if (this.pageType == 4) { //ブランド ショールーム一覧の場合 
                    return 'showroom_detail';
                } else if (this.pageType == 5) { //ショールーム ショップ一覧の場合 
                    return 'shop_detail';
                } else if (this.pageType == 6) { //ショールーム ブランド一覧の場合 
                    return 'brand_detail';
                }
            },
            mySelectRooms() {
                if (this.brandList) { //ショップユーザーの場合
                    if (this.brandList.data.length > 0) {
                        if (this.user.shop_id) {
                            var shop_id = this.user.shop_id;
                        } else {
                            var shop_id = this.shops[this.list_index].id;
                        }
                        this.select_id = shop_id;
                        return this.brandList.data;
                    } else return null;
                } else if (this.shopList) { //ブランドユーザーの場合
                    if (this.shopList.data.length > 0) {
                        if (this.user.brand_id) {
                            var brand_id = this.user.brand_id;
                        } else {
                            var brand_id = this.brands[this.list_index].id;
                        }
                        this.select_id = brand_id;
                        return this.shopList.data;
                    } else return null;
                }
            },
            allEmployees() {
                if(this.employees) {
                    return this.employees;
                } else return null;
            },
            backName() {
                if (this.user.type == 0) {
                    return 'Admin';
                } else if (this.user.type == 1) {
                    return 'Shop';
                } else if (this.user.type == 2) {
                    return 'Brand';
                } else if (this.user.type == 3) {
                    return 'ShowRoom';
                }
            },
        }
    }
</script>
